import React from 'react';
import PropTypes from 'prop-types';
import styles from './label.module.css';

/**
 * Generic Label component that accepts any native HTML label props.
 * @param {React.LabelHTMLAttributes<HTMLLabelElement>} props
 */
export const Label = ({ className = '', children, ...props }) => {
	const labelClass = `${styles.label} ${className}`.trim();
	return (
		<label className={labelClass} {...props}>
			{children}
		</label>
	);
};

Label.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
};
